<template src="./footer.html"></template>

<script>
    export default {}
</script>

<style>

</style>
